import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LoginOrRegister from 'components/auth/LoginOrRegister';
import queryString from 'query-string';

import helpers from 'utils/helpers';
import { authorizationRequest } from 'ducks/auth';

import { addCouponRequest } from 'ducks/users';

class LoginGroup extends Component {
  state = {};

  handlePageChange = (page, options = {}) => {
    const { email } = options;
    this.props.history.push(`${process.env.PUBLIC_URL}/${page}`);

    this.setState({
      page,
      email
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.registerSuccess && this.props.registerSuccess) {
      console.warn('login page');
      if (localStorage.getItem('register.coupon')) {
        this.props.addCouponRequest({
          user: this.props.user,
          code: localStorage.getItem('register.coupon')
        });
      }

      helpers.clearLocalStorage('register');
    }

    if (
      this.props.user ||
      (!prevProps.user && this.props.user) ||
      (!prevProps.basic && this.props.basic)
    ) {
      if (this.props.basic) {
        return this.props.history.push(
          `${process.env.PUBLIC_URL}/create-shipment/quotation`
        );
      }

      if (this.state.page === 'basic') return;
      const params = queryString.parse(this.props.location.search);

      return this.setState({
        page: 'basic',
        type: params.type === 'business' ? 'business' : 'personal'
      });
    }

    if (prevProps.page !== this.props.page) {
      this.setState({
        page: this.props.page
      });
    }
  }

  componentDidMount() {
    this.props.authorizationRequest();

    this.setState({
      page: this.props.page
    });
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>{this.props.t('auth.login.header.title')}</title>
        </Helmet>
        <div
          style={{
            padding: '0 15px 10px',
            flex: '1 0 auto',
            backgroundColor: '#fafafa',
            margin: '0 auto',
            width: '100%',
            maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
          }}>
          <LoginOrRegister
            email={this.state.email}
            page={this.state.page}
            type={this.state.type}
            onPageChange={this.handlePageChange}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  authorizationRequest,
  addCouponRequest
};

const mapStateToProps = state => {
  return {
    loading: !!state.auth.loading,
    user: state.auth.user || false,
    basic: !!state.auth.basic,
    authRequestSuccess: !!state.auth.authRequestSuccess,
    registerSuccess: !!state.auth.registerSuccess
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginGroup))
);
